import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { m as s } from "motion/react";
import { useAnimateFadeIn as n } from "../../../animation/animation.js";
import "react";
import "dayjs";
import "react-i18next";
import { PrimaryButtonLink as d } from "../../elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import i from "./cta-block.module.less.js";
const I = ({ title: t, text: a, linkButton: r }) => {
  const m = n({ whileInView: !0, easing: "easeInOut" });
  return /* @__PURE__ */ e(s.section, { ...m, className: "max-width padded-sides centered space-mb-2xl", children: /* @__PURE__ */ e("div", { className: i.backgroundWrapper, children: /* @__PURE__ */ o("div", { className: [i.contentWrapper, "text-max-width centered"].join(" "), children: [
    /* @__PURE__ */ e("h3", { className: i.title, children: t }),
    a && /* @__PURE__ */ e("p", { className: "body-base", children: a }),
    r && /* @__PURE__ */ e(
      d,
      {
        url: r?.url,
        label: r?.title,
        onPreNavigate: r.onPreNavigate
      }
    )
  ] }) }) });
};
export {
  I as CTABlock,
  I as default
};
